module.exports = __webpack_public_path__ + "img/webpack.b7bef091.svg";